const ERRORS = {
  ORG_NOT_FOUND: 'Your organization does not exist',
  ORG_REQUIRED: 'Organization is required',

  LOGIN_FAILED: 'Authentication failed',
  USERNAME_REQUIRED: 'Your email is required',
  USERNAME_WRONG: 'Your email may not be correct',
  PASSWORD_WRONG: 'Your password may not be correct',
  PASSWORD_REQUIRED: 'Your password is required',

  UNKNOWN_ERROR: 'Error occured. Please contact us for further supports.'
}

export default ERRORS
